// Dependencies
import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation } from 'swiper/modules'

// Styles
import {
  Container,
  ContentWrapper,
  TextContent,
  Title,
  Description,
  CarouselContent,
  AboutCarouselItem,
  AboutCarouselItemDescription,
  AboutCarouselItemTitleLabel,
  AboutCarouselItemTitleWrapper,
  AboutCarouselItemTitleIndex,
  CarouselIconsWrapper,
  CarouselLeftIcon,
  CarouselRightIcon
} from './sisu-carousel.styles'
import 'swiper/css'

// Assets
import chevronRight from 'assets/chevron-right-red.svg'
import chevronLeft from 'assets/chevron-left-red.svg'

// Data
import { carouselData } from './sisu-carousel.mock'
import { CaroulselIcon } from '../Carousel/carousel.styles'

export const SisuCarousel: React.FC = () => {
  return (
    <Container>
      <ContentWrapper>
        <TextContent>
          <Title>Veja como funciona o simulador do Pro</Title>

          <Description>
            Sabe aquela ansiedade de esperar os resultados do SiSU? Nosso
            simulador está aqui para acabar com ela! Com a gente, você pode
            prever suas chances nas universidades antes mesmo dos resultados
            oficiais. Legal, né? Vem ver por que nosso simulador é uma
            ferramenta essencial:
          </Description>
        </TextContent>

        <CarouselContent>
          <Swiper
            slidesPerView={1.2}
            spaceBetween={24}
            modules={[Navigation]}
            navigation={{
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev'
            }}
            breakpoints={{
              768: { slidesPerView: 2.3 },
              1366: { slidesPerView: 4 }
            }}
          >
            {carouselData.map((item, index) => (
              <SwiperSlide>
                <AboutCarouselItem key={index}>
                  <AboutCarouselItemTitleWrapper>
                    <AboutCarouselItemTitleIndex>
                      {index + 1}
                    </AboutCarouselItemTitleIndex>
                    <AboutCarouselItemTitleLabel>
                      {item.title}
                    </AboutCarouselItemTitleLabel>
                  </AboutCarouselItemTitleWrapper>

                  <AboutCarouselItemDescription>
                    {item.description}
                  </AboutCarouselItemDescription>
                </AboutCarouselItem>
              </SwiperSlide>
            ))}

            <CarouselIconsWrapper>
              <CarouselLeftIcon className="swiper-button-prev">
                <CaroulselIcon src={chevronLeft} />
              </CarouselLeftIcon>
              <CarouselRightIcon className="swiper-button-next">
                <CaroulselIcon src={chevronRight} />
              </CarouselRightIcon>
            </CarouselIconsWrapper>
          </Swiper>
        </CarouselContent>
      </ContentWrapper>
    </Container>
  )
}
